// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import Button from '@ott/button';

import styles from './styles.scss';

export default ({ innerRef }) => (
  <Button innerRef={innerRef} className={styles.SearchFormButton} type="submit">
    Найти
  </Button>
);
